module.exports = __webpack_public_path__ + "img/ic-voluntery.a32d2050.svg";